import * as React from "react";
import * as ReactDOM from "react-dom";
import {Provider} from "react-redux";
import {store} from "../store/store";
import Preloader from "./screens/preloader/Preloader";
import {SCREENS} from "../store/reducers/screen";
import Game from "./screens/game/Game";
import GameIntro from "./screens/game-intro/GameIntro";
import MainMenu from "./screens/main-menu/MainMenu";
import DebugConsole from "./debug/DebugConsole";
import MiniGame from "./screens/mini-game/MiniGame";
import Leaderboard from "./screens/leaderboard/Leaderboard";
import HowToPlay from './screens/how-to-play/HowToPlay';

export interface IPowerMapGameProps
{

}

import './PowerMapGame.scss';

export class PowerMapGame extends React.Component<IPowerMapGameProps, null>
{
    constructor(public props: IPowerMapGameProps)
    {
        super(props);
    }


    /**
     * render the component
     * @returns {JSX.Element}
     */
    render() : JSX.Element
    {
        return <Provider store={store}>

            <div styleName={'power-map-game'}>

                <Preloader screen={SCREENS.PRELOADER}/>
                <GameIntro screen={SCREENS.INTRO}/>
                <HowToPlay screen={SCREENS.HOW_TO_PLAY}/>
                <Leaderboard screen={SCREENS.LEADERBOARD}/>
                <GameIntro screen={SCREENS.GAME_INTRO}/>
                <Game screen={SCREENS.GAME}/>
                <MiniGame screen={SCREENS.MINI_GAME}/>
                <MainMenu screen={SCREENS.MAIN_MENU}/>

                <DebugConsole />

            </div>

        </Provider>
    }
}



// WEBPACK FOOTER //
// ./src/ts/app/PowerMapGame.tsx